import React, {useState} from 'react';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import PropTypes from "prop-types";

const DatePickerInput = ({label, className, isRequired, id, disabled,}) => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <div className={`form-item date-picker ${className}`}>
      <DatePicker
        disabled={disabled}
        id={id}
        dateFormat="d MMMM yyyy"
        selected={startDate}
        onChange={date => setStartDate(date)}
        required={isRequired}
        className="date-picker"
      />
      {label && <label htmlFor={id}
        className={isRequired && 'required'}>{label}</label>}
    </div>
  );
};

DatePickerInput.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  id: PropTypes.string,
}

DatePickerInput.defaulProps = {
  disabled: false,
  isRequired: false,
  id: '',
}

export default DatePickerInput;
